import { onMounted } from 'vue'

import { SfLog } from '@app/adapters/logger'
import { onNextPageTeardown } from '@app/adapters/page-teardown'
import { useChecksStore } from '@app/application/sf-assistant-checks/stores/checks'
import type { ProgressStatus } from '@app/application/sf-assistant-checks/constants'
import { progressStatus } from '@app/application/sf-assistant-checks/constants'
import { getSfAssistantChecksData } from '@app/application/sf-assistant-checks/utils'
import useSfPolling from '@app/shared/vue/composables/use-sf-polling'

export default function useSfAssistantChecks(): void {
  const checksStore = useChecksStore()
  async function setupChecks(): Promise<void> {
    if (
      [
        progressStatus.DONE as ProgressStatus,
        progressStatus.STARTED as ProgressStatus,
      ].includes(checksStore.setupStatus)
    ) {
      return
    }

    const data = getSfAssistantChecksData()

    if (
      data.lastMessagebusId !== undefined &&
      data.channel &&
      data.showElement
    ) {
      checksStore.setupStatus = progressStatus.STARTED

      checksStore.accountId = data.parsedAccountId
      checksStore.reconciliationId = data.parsedReconciliationId
      checksStore.showGeneral = !!data.showGeneral

      await checksStore.receiveChecks()

      const { startPolling } = useSfPolling()

      const stopPolling = startPolling(
        data.channel,
        data.lastMessagebusId,
        checksStore.refreshChecks.bind(checksStore),
        checksStore.receiveChecks.bind(checksStore)
      )

      onNextPageTeardown(stopPolling)

      checksStore.setupStatus = progressStatus.DONE
    }
  }

  onMounted((): void => {
    setupChecks().catch((error) => {
      SfLog.error('Error setting up SF Assistant checks', {
        error: error as unknown,
      })
    })
  })
}
